<template>
  <div class="comment-list">
    <ul>
      <li v-for="item in list" :key="item.id">
        <img class="avatar" :src="item.avatar" />
        <div class="contents">
          <div class="info">
            <span class="sp1">
              <div>{{item.user_name}}</div>
              <div>{{ item.created_at }}</div>
            </span>
            <font>{{item.course||item.book}}</font>
            <span class="sp2" style="padding-right:50px;float:right;">赞 {{ item.like_number }}</span>
          </div>
          <p class="article">{{item.content}}</p>
          <p class="images" v-if="item.images" style="display:block;">
              <img v-for="(img,index) in splitImages(item.images)" :key="index" :src="img" style="width:90px;height:60px;"/>
          </p>
          <p class="action-button">
            <Button type="text" v-if="item.free > 0" class="red" size="small" @click="cancAnswerPrice(item.id)">取消付费问答-</Button>
            <Button type="text" v-else size="small" @click="openAnswerPriceModel(item)">设为付费问答-</Button>
            <Button type="text" size="small" @click="deleteCom(item.id)">删除</Button>
          </p>

          <div class="repay-answer" v-for="(ans,i) in item.child.data" :key="i">
            <div class="user-info">
              <img class="avatar" :src="ans.avatar"/>
              <span class="user-name">{{ans.user_name}}</span>

              <span class="sp2" align="right" style="padding-right:50px;float:right;">赞 {{ ans.like_number }}</span>
            </div>
              <p>
                <span v-if="ans.ait">回复 <span class="color">@{{ans.ait}}</span></span>
                {{ ans.content }}
              </p>
              <span >{{ ans.created_at }}</span>

              <p  style="padding-right:50px;float:right;">
              <Button type="text" align="right" size="small" @click="deleteCom(ans.id)">删除</Button>
              </p>
          </div>
        </div>

      </li>
    </ul>
    <div class="pager">
      <Page
        class="f-right"
        show-total
        @on-page-size-change="pageSizeChange"
        @on-change="changePage"
        :total="total"
        show-elevator
        show-sizer
        transfer
      />
    </div>

    <Modal
      v-model="showPriceModal"
      title="设置为付费问答"
      :closable="true"
      :mask-closable="true"
      ok-text="确认"
      cancel-text="取消"
      @on-ok="setAnswerPrice"
      @on-cancel="showPriceModal=false"
    >

      <Form :refs="priceForm" v-model="priceForm" inline :label-width="70">
        <FormItem label="问答费用">
          <Input
            type="number"
            v-model="priceForm.price"
            placeholder="请输入费用（元）"
          />
          <span class="promt">提示：该费用将由平台、讲师、用户三方分成</span>
        </FormItem>
      </Form>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "Answer",
  props: {
    search: {
      type: Object
    },
    dataUrl: {
      type: String
    },
    method: {
      type: String,
      default: "get"
    },
    hasLabel: {
      type: Boolean,
      default: false
    },
    formatter: {
      type: Function
    },
    deleteHandler: {
      type: Function
    }
  },
  data() {
    return {
      page: 1,
      limit: 10,
      total: 0,
      valueDisabled: 2,
      list: [],
      showPriceModal: false,
      priceForm: {
        price: 0
      },
    };
  },
  methods: {
    getData(refresh) {
      if (refresh) {
        this.page = 1;
      }
      let obj = {
        page: this.page,
        limit: this.limit,
        ...this.search
      };
      this.$http[this.method](this.dataUrl, obj).then(res => {
        res.list.forEach(item => {
          if (item.comment_tag) item.comment_tag = item.comment_tag.split(",");
          if (this.formatter) {
            this.formatter(item);
          }
        });
        this.list = res.list;
        this.total = res.total;
      });
    },
    pageSizeChange(d) {
      this.limit = d;
      this.getData(true);
    },
    changePage(d) {
      this.page = d;
      this.getData(false);
    },
    searchRefresh() {
      this.getData(true);
    },
    deleteCom(id) {
      this.$Modal.confirm({
        title: "删除",
        content: "<p>确定要删除该回答吗？</p>",
        onOk: () => {
          this.del(id);
        },
        onCancel: () => {}
      });
    },
    del(id) {
      if (this.deleteHandler) {
        this.deleteHandler(id);
      } else {
        this.$http.delete("/api/ask/ask/delAskComment",{id}).then(() => {
          this.searchRefresh();
        });
      }
    },

    topAsk(id) {
      this.$http.put("/api/ask/changeTopHot",{id, type: 1}).then(res => {
        this.detail.is_top = !this.detail.is_top;
      });
    },

    hotAsk(id) {
      this.$http.put("/api/ask/changeTopHot",{id, type: 2 }).then(res => {
        this.detail.is_hot = !this.detail.is_hot;
      });
    },

    openAnswerPriceModel(item)
    {
      this.showPriceModal = true;
      this.priceForm = item;
    },

    setAnswerPrice() {
      this.$http
        .put(`/api/ask/ask/setFree`, { id:this.priceForm.id,  price: this.priceForm.price*100})
        .then(() => {
            this.showPriceModal = false;
            this.searchRefresh();
        });
    },

    cancAnswerPrice(id) {
      this.$Modal.confirm({
        title: "取消",
        content: "<p>确定取消付费回答吗?</p>",
        onOk: () => {
          this.$http
            .put(`/api/ask/ask/setFree`, { id,  price: 0})
            .then(() => {
                this.showPriceModal = false;
                this.searchRefresh();
            });
        },
        onCancel: () => {}
      });
    },
    splitImages(images){
      return images.split(',');
    }
  },
  created() {
    this.getData(true);
  }
};
</script>

<style lang="scss" scoped>
.comment-list {
  font-family: Arial, Helvetica, sans-serif;
  .no-comment {
    text-align: center;
    height: 90px;
    line-height: 90px;
    font-size: 14px;
  }
  ul {
    overflow: hidden;
    padding: 0 10px 30px;
    li {
      border: 1px solid rgb(223, 218, 218);
      border-radius: 5px;
      display: flex;
      margin-top: 20px;
      padding: 30px 0;
      .avatar {
        width: 50px;
        height: 50px;
        border-radius: 50%;
        margin-left: 30px;
        margin-right: 20px;
        flex: none;
        border: 1px solid #ccc;
      }
      .contents {
        display: flex;
        flex-direction: column;
        flex: 1;
        position: relative;
        .info {
          display: flex;
          align-items: center;
          .sp1 {
            font-size: 12px;
            color: #333;
            margin-right: 20px;
          }
          .sp2 {
            font-size: 14px;
            color: #999;
            margin-left: 30px;
          }
          font {
            font-size: 14px;
            color: #2d8cf0;
            margin-right: 30px;
          }
        }
        .action-button{
          position: absolute;
          right: 50px;
        }
        .label {
          span {
            display: inline-block;
            padding: 0 8px;
            font-size: 12px;
            color: #333;
            margin-right: 10px;
            margin-top: 6px;
            border: 1px solid #ccc;
            background: #f8f8f8;
            border-radius: 4px;
          }
        }
        .article {
          margin-top: 10px;
          font-size: 15px;
          color: #333;
          width: 90%;
        }
      }
      .delete {
        width: 100px;
        font-size: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #2d8cf0;
        span {
          cursor: pointer;
        }
      }
      .images {
        img {
          width: 100px;
          padding: 10px 0;
          margin: 10px;
        }
      }
    }
    .repay-answer{
      padding: 10px 10px;
      background: #f1f1f1;
      border-top: 1px solid #dddddd;
      .user-info{

      }
      .avatar{
        width: 25px;
        height: 25px;
        margin: 0;
        padding: 0;
        border: 1px solid #ccc;
      }
      .user-name{
        display: inline-block;
      }
    }
    .repay-answer:hover{
      background: #dddddd;
    }
  }
  .red{ color: #f0f0f0;}
  .color{
    color: $primary_color;
  }
}
</style>
